/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { SubscribeFormI18n } from 'widgets/SubscribeFormSection';

import './SubscribeBlock.css';

const SubscribeBlock = ({ t }) => (
  <div className="search-subscribe-block">
    <div className="subscribe-text-col">
      <h3>{t('Didn\'t find an appropriate option?')}</h3>
      <p>{t('Try other dates or bike type, your desired scooter could appear in motorbikes category! If even though there is nothing appropriate - guys from support team will definitely help you to find desired variant.')}</p>
    </div>

    <div className="subscribe-form-col">
      <h3>{t('Do you want to receive price alerts and updates about new bikes become available?')}</h3>

      <SubscribeFormI18n
        inputPlaceholder="Your email address"
        buttonText="Subscribe"
      />
    </div>
  </div>
);

SubscribeBlock.propTypes = {
  t: PropTypes.func.isRequired
};

export default translate(['translation'])(SubscribeBlock);



// WEBPACK FOOTER //
// ./src/components/SearchPage/SubsctibeBlock/SubscribeBlock.js